import { Model } from '@vuex-orm/core'

export default class Organization extends Model {
  static entity = 'organizations'

  static primaryKey = 'id'

  static fields () {
    return {
      id: this.attr(null),
      name: this.string(''),
      isActivated: this.boolean(false),
      adminUserId: this.attr(null),
      currentSeats: this.number(1),
      currentGroups: this.number(0)
    }
  }
}
